import Button from "../../../../componentes/button/button";
import AcaoButtons from "../../Shared/AcaoButtons";

// Etapa "Análise" — apenas Aprovar/Reprovar (reprovar cancela a solicitação).
export default function EtapaMultaAnalise({ acoes = [], acaoEmExecucao, onExecutarAcao }) {
    const podeAprovar = acoes.includes("APROVAR");
    const outrasAcoes = acoes.filter(a => a !== "APROVAR");

    function executar(acao) {
        onExecutarAcao(acao, {});
    }

    return (
        <div className="flex justify-between gap-2 flex-wrap">
            <div className="flex flex-col gap-4">
                <p className="text-sm text-muted-foreground">Aprovar Solicitação para reconhecimento do Condutor</p>
            </div>
            <div className="flex gap-2 flex-wrap">
                <AcaoButtons acoes={outrasAcoes} acaoEmExecucao={acaoEmExecucao} onAcao={executar} />
                {podeAprovar && (
                    <Button
                        variant="green"
                        label="Aprovar"
                        iconLeft="fa fa-check-circle"
                        loading={acaoEmExecucao === "APROVAR"}
                        onClick={() => executar("APROVAR")}
                    />
                )}
            </div>
        </div>
    );
}
